import environment from '@/environment';
import {isModelVersion, ModelVersion} from '@/model/types/model-versions';

export const resolveDebugModelVersion = (debugModelVersion: string | null | undefined): ModelVersion | null => {
  if (!environment.DEBUG || !debugModelVersion) {
    return null;
  }

  if (!isModelVersion(debugModelVersion)) {
    return null;
  }

  return debugModelVersion;
};

export const resolveEffectiveModelVersion = (
  modelVersion: string,
  debugModelVersion: string | null | undefined,
): string => resolveDebugModelVersion(debugModelVersion) ?? modelVersion;
